/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { DtoRegistryOfficeUpdate } from '../../models/dto-registry-office-update';
import { RegistryOfficeItem } from '../../models/registry-office-item';

export interface OfficeControllerUpdate$Params {
  idOffice: number;
      body: DtoRegistryOfficeUpdate
}

export function officeControllerUpdate(http: HttpClient, rootUrl: string, params: OfficeControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: RegistryOfficeItem;
}>> {
  const rb = new RequestBuilder(rootUrl, officeControllerUpdate.PATH, 'patch');
  if (params) {
    rb.path('idOffice', params.idOffice, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: RegistryOfficeItem;
      }>;
    })
  );
}

officeControllerUpdate.PATH = '/registry/office/{idOffice}';
